import gql from "graphql-tag"

export const MEDIASET_ATTRIBUTES_FRAGMENT = gql`
  fragment MediaSetAttributesFragment on MediaSet {
    id
    videos {
      videoType
      videoUrl
    }
    progressImages {
      imageType
      originalImageUrl
    }
  }
`

export const MEDIASET_FRAGMENT = gql`
  fragment MediaSetFragment on User {
    id
    eCommerceUser
    activeJourneys {
      kind
      mediaSet {
        ...MediaSetAttributesFragment
      }
    }
  }
  ${MEDIASET_ATTRIBUTES_FRAGMENT}
`
